(function () {
  function initialize(root) {
    if (!root || root.dataset.nccReady === 'true') return;

    var hand = root.querySelector('[data-ncc-hand]');
    var toneLabel = root.querySelector('[data-ncc-tone-label]');
    var captionTone = root.querySelector('[data-ncc-caption-tone]');
    var captionName = root.querySelector('[data-ncc-caption-name]');
    var captionDetail = root.querySelector('[data-ncc-caption-detail]');
    var productLink = root.querySelector('[data-ncc-shop]');
    var tone = root.querySelector('[data-ncc-tone][aria-pressed="true"]');
    var shade = root.querySelector('[data-ncc-shade][aria-pressed="true"]');

    if (!hand || !tone || !shade) return;
    root.dataset.nccReady = 'true';

    function setPressed(selector, active) {
      root.querySelectorAll(selector).forEach(function (button) {
        button.setAttribute('aria-pressed', button === active ? 'true' : 'false');
      });
    }

    function update() {
      var toneName = tone.dataset.label;
      var shadeName = shade.dataset.name;
      var shadeSlug = shade.dataset.slug;
      var imageUrl = tone.getAttribute('data-image-' + shadeSlug);
      var productUrl = shade.dataset.productUrl;

      if (imageUrl && hand.getAttribute('src') !== imageUrl) {
        hand.classList.remove('is-ready');
        hand.setAttribute('src', imageUrl);
      }

      hand.setAttribute('alt', toneName + ' hand wearing ' + shadeName + ' professionally rendered polish');
      toneLabel.textContent = toneName;
      captionTone.textContent = toneName + ' · Oval · Medium';
      captionName.textContent = shadeName;
      captionDetail.textContent = shade.dataset.detail || '';

      if (productUrl) {
        productLink.href = productUrl;
        productLink.hidden = false;
      } else {
        productLink.removeAttribute('href');
        productLink.hidden = true;
      }

      if (hand.complete && hand.naturalWidth) hand.classList.add('is-ready');
    }

    hand.addEventListener('load', function () {
      hand.classList.add('is-ready');
    });

    root.querySelectorAll('[data-ncc-tone]').forEach(function (button) {
      button.addEventListener('click', function () {
        tone = button;
        setPressed('[data-ncc-tone]', tone);
        update();
      });
    });

    root.querySelectorAll('[data-ncc-shade]').forEach(function (button) {
      button.addEventListener('click', function () {
        shade = button;
        setPressed('[data-ncc-shade]', shade);
        update();
      });
    });

    update();
  }

  function initializeAll(scope) {
    var target = scope || document;
    if (target.matches && target.matches('[data-ncc]')) initialize(target);
    target.querySelectorAll('[data-ncc]').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
